import jazzcashLogo from "@/assets/jazzcash.png";
import easypaisaLogo from "@/assets/easypaisa.png";

export const PAYMENT_METHODS = [
  {
    id: "JazzCash",
    name: "JazzCash",
    logo: jazzcashLogo,
    minAmount: 100,
    bgSelected: "bg-red-50 border-red-300 ring-2 ring-red-200",
    bgHover: "hover:bg-red-50/50",
  },
  {
    id: "EasyPaisa",
    name: "EasyPaisa",
    logo: easypaisaLogo,
    minAmount: 500,
    bgSelected: "bg-emerald-50 border-emerald-300 ring-2 ring-emerald-200",
    bgHover: "hover:bg-emerald-50/50",
  },
];
